import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import { message } from "antd";
import { paymentProvider } from "./paymentProvider";
import { redeemLoyality } from "./loyality";
import i18next from "i18next";
import dayjs from "dayjs";
import upsertPOSLog from "../../Retail/posLog";
import { verifyCredit, upsertCreditTransaction } from "../../../../services";
import messages from "../../../../errors/messages.en-IN.json";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";

export const addAmount = async (
  paymentMethod,
  value,
  grant,
  cart,
  setCart,
  setLoader,
  setPaymentModal,
  setAmount,
  setLoyalityOtpData,
  setLoyalityOtpModalVisible,
  setSelectedPaymentMethod,
  setPaytmQrCodeModalOpens,
  setQrCodeResponse,
  overPayedAmount,
  setShowCardPaymnteModal,
  setCardPaymnetError,
  setCardPaymnetStatus,
  setCardPaymnetStatusPLB,
  setLoading,
  setIsCardPaymentLoading,
  setLayoutType,
  setKioskUI,
  dispatchQRCodeEvent,
  closeQRCodeModal,
  wallet,
  cardPaymentDetails,
  setIntegratedPaymentStatus,
  exchangeCart,
  setExchangeCart,
  processOrder,
  showCustomerWallet,
  handleWalletPostPayment,
  isNewGiftCardFlag,
  showGiftCardTopup,
  handleGiftCardTopupPostPayment
) => {
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const tillData = useAuthStore.getState().tillData;
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const tillLayout = parseInt(tillaccess?.layout == null ? 1 : tillaccess?.layout);
  const newPaymentAmount = parseFloat(value).toFixed(pricePrecision);
  const t = i18next.t;
  let setAuthTokens;
  let amountAdded;
  const authHeaders = await getOAuthHeaders();
  if (authHeaders && authHeaders.access_token) {
    setAuthTokens = authHeaders.access_token;
  }
  if (cart.payments.length > 0) {
    const currentPaymentsTotal = cart.payments
      .reduce((total, payment) => {
        const paymentAmount = parseFloat(payment.amount);
        return isNaN(paymentAmount) ? total : total + paymentAmount;
      }, 0)
      .toFixed(pricePrecision);

    // Calculate the new total by adding the currentPaymentsTotal and newPaymentAmount
    amountAdded = (parseFloat(currentPaymentsTotal) + parseFloat(newPaymentAmount)).toFixed(pricePrecision);

    // Now, amountAdded contains the sum of amounts in the payments array
  } else {
    amountAdded = parseFloat(value).toFixed(pricePrecision);
  }
  if (grant !== undefined) {
    completePayment(
      paymentMethod,
      value,
      cart,
      setCart,
      setAmount,
      setSelectedPaymentMethod,
      overPayedAmount,
      setLayoutType,
      setKioskUI,
      wallet,
      pricePrecision,
      setExchangeCart,
      showCustomerWallet,
      handleWalletPostPayment,
      isNewGiftCardFlag,
      showGiftCardTopup,
      handleGiftCardTopupPostPayment
    );
  } else {
    const validation = RegExp(`^[0-9]+(.[0-9]{1,${pricePrecision}})?$`);
    const absValue = Math.abs(parseFloat(value));
    let overPaymentFlag = false;

    if (wallet && showCustomerWallet) {
      try {
        const stored = JSON.parse(localStorage.getItem("walletDataForCardIntegration"));

        if (stored) {
          const totalPayments = Number.parseFloat(stored.totalPayments || 0);
          const paymentAmount = Number.parseFloat(value || 0);
          const topupTotal = Number.parseFloat(stored.topupTotal || 0);

          overPaymentFlag = totalPayments + paymentAmount <= topupTotal;
        } else {
          overPaymentFlag = true;
        }
      } catch (e) {
        console.error("walletDataForCardIntegration parse error", e);
        overPaymentFlag = true;
      }
    } else if (isNewGiftCardFlag && showGiftCardTopup) {
      overPaymentFlag = true;
    } else {
      // In exchange mode, use combined net total (exchange + return) instead of just cart.total
      // which is negative (return value) and would block all non-cash payments.
      if (isExchange) {
        const exchCartObj = useCartStore.getState().exchangeCart || {};
        const combinedNet = Math.abs((exchCartObj.total || 0) + (cart.total || 0));
        const totalPaid = exchCartObj.paid || 0;
        overPaymentFlag = paymentMethod?.name?.toLowerCase() !== "cash" ? totalPaid + parseFloat(value) <= combinedNet + overPayedAmount : false;
      } else {
        overPaymentFlag = paymentMethod?.name?.toLowerCase() !== "cash" ? cart.paid + parseFloat(value) <= cart.total + overPayedAmount : false;
      }
    }
    if (paymentMethod !== undefined && paymentMethod !== "" && validation.test(absValue) && (parseFloat(value) > 0 || isExchange || cart?.isReturn)) {
      const currentPaymentMethod = paymentMethod;
      if ((currentPaymentMethod.integratedPayment || currentPaymentMethod.integratedPayment === false) && overPaymentFlag && !currentPaymentMethod.isloyalty && !currentPaymentMethod.iscredit && !currentPaymentMethod.isGiftCard) {
        if (wallet && showCustomerWallet) {
          setAmount(value);
        }
        await paymentProvider(
          amountAdded,
          currentPaymentMethod,
          paymentMethod,
          value,
          cart,
          setCart,
          setLoader,
          setPaymentModal,
          completePayment,
          setSelectedPaymentMethod,
          setAmount,
          setPaytmQrCodeModalOpens,
          setQrCodeResponse,
          setShowCardPaymnteModal,
          setCardPaymnetError,
          setCardPaymnetStatus,
          setCardPaymnetStatusPLB,
          setLoading,
          setIsCardPaymentLoading,
          setLayoutType,
          setKioskUI,
          dispatchQRCodeEvent,
          closeQRCodeModal,
          wallet,
          cardPaymentDetails,
          setIntegratedPaymentStatus,
          showCustomerWallet,
          handleWalletPostPayment,
          isNewGiftCardFlag,
          showGiftCardTopup,
          handleGiftCardTopupPostPayment
        );
      } else if ((currentPaymentMethod.integratedPayment || currentPaymentMethod.integratedPayment === false) && wallet && !currentPaymentMethod.isloyalty && !currentPaymentMethod.iscredit && !currentPaymentMethod.isGiftCard) {
        await paymentProvider(
          amountAdded,
          currentPaymentMethod,
          paymentMethod,
          value,
          cart,
          setCart,
          setLoader,
          setPaymentModal,
          completePayment,
          setSelectedPaymentMethod,
          setAmount,
          setPaytmQrCodeModalOpens,
          setQrCodeResponse,
          setShowCardPaymnteModal,
          setCardPaymnetError,
          setCardPaymnetStatus,
          setCardPaymnetStatusPLB,
          setLoading,
          setIsCardPaymentLoading,
          setLayoutType,
          setKioskUI,
          dispatchQRCodeEvent,
          closeQRCodeModal,
          wallet,
          cardPaymentDetails,
          setIntegratedPaymentStatus,
          showCustomerWallet,
          handleWalletPostPayment,
          isNewGiftCardFlag,
          showGiftCardTopup,
          handleGiftCardTopupPostPayment
        );
      }
      if (currentPaymentMethod.iscredit && overPaymentFlag) {
        cart.advancePayment = cart.advancePayment ? cart.advancePayment : 0;
        const posConfig = usePOSConfigStore.getState().posConfig;
        if (useTransactionStore.getState().isCreditSale === "true" && posConfig?.generateInvoiceForCreditSale !== "Y") {
          processOrder?.();
          // completePayment(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, overPayedAmount, setLayoutType, setKioskUI, wallet, precision, setExchangeCart);
        } else if ((cart.customer.iscredit && value <= cart.total - cart.paid) || (cart.isReturn && cart.customer.iscredit)) {
          setLoader(true);
          setPaymentModal(false);
          try {
            const creditResponse = await verifyCredit(cart.customer.cwrCustomerId, value);
            const { iscredit, creditLimit, creditBalance } = creditResponse.data.data.verifyCredit;
            const verifyCreditMessage = creditResponse.data.data.verifyCredit.message;
            if (iscredit) {
              if (amountAdded > 0 && amountAdded <= creditBalance) {
                const trxData = [
                  {
                    b2cCustomerId: cart.customer.cwrCustomerId,
                    trxDate: dayjs(new Date()).format("YYYY-MM-DD"),
                    trxAmt: Number(value),
                    openingAmt: cart?.customer?.creditBalance,
                    closingAmt: creditBalance,
                    type: "DR",
                    cwrTillId: null,
                    sOrderId: null,
                    referenceNo: cart?.referenceId,
                  },
                ];
                const creditUpsertResponse = await upsertCreditTransaction(trxData);
                if (creditUpsertResponse?.data?.data?.upsertCreditTransaction?.status === "200") {
                  message.success(`${t(verifyCreditMessage)}`);
                  completePayment(
                    paymentMethod,
                    value,
                    cart,
                    setCart,
                    setAmount,
                    setSelectedPaymentMethod,
                    overPayedAmount,
                    setLayoutType,
                    setKioskUI,
                    wallet,
                    pricePrecision,
                    setExchangeCart,
                    showCustomerWallet,
                    handleWalletPostPayment,
                    isNewGiftCardFlag,
                    showGiftCardTopup,
                    handleGiftCardTopupPostPayment
                  );
                }
              } else {
                {
                  message.warning(`${t("credit_payment_less_amount_error")}`);
                }
              }
            } else {
              message.warning(`${messages.errors.payments.eligible_customer}`);
            }
          } catch (err) {
            console.error(err);
            message.error(`${messages.info.payment_failed}!`);
          } finally {
            setLoader(false);
            if (tillLayout === 2) {
              setPaymentModal(true);
            }
          }
        } else {
          {
            message.warning(`${t("credit payment is can not be more than sale amount")}`);
          }
        }
      } else if (currentPaymentMethod.isloyalty && overPaymentFlag) {
        setLoader(true);
        const loyaltyCompletePayment = (pm, val, cartObj, sc, sa, spm) => {
          completePayment(pm, val, cartObj, sc, sa, spm, overPayedAmount, setLayoutType, setKioskUI, wallet, pricePrecision, setExchangeCart, showCustomerWallet, handleWalletPostPayment, isNewGiftCardFlag, showGiftCardTopup, handleGiftCardTopupPostPayment);
        };
        try {
          await redeemLoyality(paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, setAuthTokens, loyaltyCompletePayment);
        } finally {
          setLoader(false);
        }
      } else if (currentPaymentMethod.isGiftCard && overPaymentFlag) {
        // Gift card payment requires the redeem drawer to be shown first.
        // When called from the redeem flow (grant !== undefined), payment is
        // already handled in the grant branch above.  When called directly
        // from handlePayment (grant === undefined), we must NOT complete the
        // payment here — the useEffect on selectedPaymentMethod will open the
        // GiftCardRedeemDrawer for the user to enter card number and PIN.
        return;
      } else if (
        currentPaymentMethod?.name?.toLowerCase() === "cash" ||
        (currentPaymentMethod.integratedPayment === false && currentPaymentMethod.paymentProvider === null) ||
        currentPaymentMethod?.isBankTransfer === "Y"
      ) {
        completePayment(
          paymentMethod,
          value,
          cart,
          setCart,
          setAmount,
          setSelectedPaymentMethod,
          overPayedAmount,
          setLayoutType,
          setKioskUI,
          wallet,
          pricePrecision,
          setExchangeCart,
          showCustomerWallet,
          handleWalletPostPayment,
          isNewGiftCardFlag,
          showGiftCardTopup,
          handleGiftCardTopupPostPayment
        );
      } else if (currentPaymentMethod.integratedPayment === false && currentPaymentMethod.paymentProvider === "ADC") {
        if (wallet && showCustomerWallet) {
          setAmount(value);
        }
        setShowCardPaymnteModal(true);
        setCardPaymnetError(true);
        setCardPaymnetStatus({
          paymentStatus: false,
          message: "",
          paymentMode: "",
        });
      } else if (!overPaymentFlag && !(isNewGiftCardFlag && showGiftCardTopup)) {
        // Cash always goes through — overpayment becomes change
        if (currentPaymentMethod?.name?.toLowerCase() === "cash") {
          completePayment(
            paymentMethod,
            value,
            cart,
            setCart,
            setAmount,
            setSelectedPaymentMethod,
            overPayedAmount,
            setLayoutType,
            setKioskUI,
            wallet,
            pricePrecision,
            setExchangeCart,
            showCustomerWallet,
            handleWalletPostPayment,
            isNewGiftCardFlag,
            showGiftCardTopup,
            handleGiftCardTopupPostPayment
          );
        } else {
          message.warning(`${messages.errors.cart.overpayment_not_allowed}`);
        }
      }
    }
  }
};

export const completePayment = (
  paymentMethod,
  value,
  cart,
  setCart,
  setAmount,
  setSelectedPaymentMethod,
  overPayedAmount,
  setLayoutType,
  setKioskUI,
  wallet,
  precision,
  setExchangeCart,
  showCustomerWallet,
  handleWalletPostPayment,
  isNewGiftCardFlag,
  showGiftCardTopup,
  handleGiftCardTopupPostPayment
) => {
  const tillData = useAuthStore.getState().tillData;
  const posConfig = usePOSConfigStore.getState().posConfig;
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const cartObj = cart;
  const exchangeCartObj = useCartStore.getState().exchangeCart || {};
  let activeCart = isExchange ? exchangeCartObj : cartObj;
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const cardDetails = localStorage.getItem("cardPaymentDetails") ? JSON.parse(localStorage.getItem("cardPaymentDetails")) : {};
  let netAmountToPay = activeCart.total;
  if (isExchange) {
    const updatedCartObj = { ...cartObj };

    const returnPayment = {
      ...paymentMethod,
      amount: parseFloat(cartObj.total || 0).toFixed(pricePrecision),
    };

    updatedCartObj.payments = [returnPayment];

    updatedCartObj.paid = Math.abs(parseFloat(cartObj.total || 0));
    setCart(updatedCartObj);
  }
  if (isExchange) {
    const returnTotal = cartObj.total || 0;
    const exchangeTotal = exchangeCartObj.total || 0;
    netAmountToPay = exchangeTotal + returnTotal;

    // DI-27: Cross-validate exchange payment balance
    const returnCredit = Math.abs(Number(returnTotal) || 0);
    const newCartTotal = Number(exchangeTotal) || 0;
    const expectedDue = newCartTotal - returnCredit;
    if (Math.abs(expectedDue - netAmountToPay) > 0.01) {
      console.error("[DI-27] Exchange payment balance mismatch detected", {
        returnCredit,
        newCartTotal,
        expectedDue,
        actualNetAmountToPay: netAmountToPay,
        difference: Math.abs(expectedDue - netAmountToPay),
      });
    }
  }
  if (wallet === true) {
    const amountAdded = parseFloat(value);
    const currentPaymentMethod = paymentMethod;
    let walletPayments = [];
    try {
      const storedPayments = useTransactionStore.getState().walletPayments;
      // Ensure walletPayments is an array
      walletPayments = Array.isArray(storedPayments) ? storedPayments : [];
    } catch (e) {
      console.error("Error reading walletPayments from store:", e);
      // If JSON.parse fails or stored data is invalid, keep walletPayments as an empty array
      walletPayments = [];
    }

    // Check if paymentMethod.name matches any walletPayments.name
    const matchingPaymentIndex = walletPayments.findIndex((wp) => wp.finPaymentmethodID === paymentMethod.finPaymentmethodId);

    if (matchingPaymentIndex >= 0) {
      const existing = walletPayments[matchingPaymentIndex];
      // If fin-nilPaymentmethodID matches, add the amount to the existing wallet payment
      walletPayments[matchingPaymentIndex].amount = parseFloat((parseFloat(walletPayments[matchingPaymentIndex].amount) + parseFloat(amountAdded)).toFixed(pricePrecision));
      walletPayments[matchingPaymentIndex].count = (existing.count || 1) + 1;

      // Update card details if the payment method is card
      if (currentPaymentMethod.name.toLowerCase() === "card") {
        walletPayments[matchingPaymentIndex] = {
          ...walletPayments[matchingPaymentIndex],
          transactionId: cardDetails?.transactionId || walletPayments[matchingPaymentIndex].transactionId,
          cardType: cardDetails?.cardType || walletPayments[matchingPaymentIndex].cardType,
          cardNo: cardDetails?.cardNumber || walletPayments[matchingPaymentIndex].cardNo,
          transactionTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          authorizationCode: cardDetails?.authorization || walletPayments[matchingPaymentIndex].authorizationCode,
          metaData: walletPayments[matchingPaymentIndex].metaData || [],
          count: walletPayments[matchingPaymentIndex].count || 1,
        };
      }
    } else {
      // If finPaymentmethodID doesn't match, add new payment method with amount
      currentPaymentMethod.amount = parseFloat(amountAdded).toFixed(pricePrecision);
      if (currentPaymentMethod.name.toLowerCase() === "card") {
        if (currentPaymentMethod.integratedPayment === true) {
          walletPayments.push({
            finPaymentmethodID: currentPaymentMethod.finPaymentmethodId,
            amount: parseFloat(parseFloat(currentPaymentMethod.amount)?.toFixed(precision)) || parseFloat(amountAdded),
            transactionResponse: "",
            transactionId: cardDetails?.transactionId || null,
            cardType: cardDetails?.cardType || "",
            cardNo: cardDetails?.cardNumber || "",
            transactionTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            authorizationCode: cardDetails?.authorization || null,
            metaData: [],
            count: 1,
          });
        } else {
          walletPayments.push({
            finPaymentmethodID: currentPaymentMethod.finPaymentmethodId,
            amount: parseFloat(parseFloat(currentPaymentMethod.amount)?.toFixed(precision)) || parseFloat(amountAdded),
            transactionResponse: null,
            transactionId: cardDetails?.transactionId || null,
            cardType: cardDetails?.cardType || null,
            cardNo: cardDetails?.cardNumber || null,
            transactionTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            authorizationCode: cardDetails?.authorization || null,
            metaData: [],
            count: 1,
          });
        }
      } else {
        walletPayments.push({
          finPaymentmethodID: currentPaymentMethod.finPaymentmethodId,
          amount: parseFloat(parseFloat(currentPaymentMethod.amount)?.toFixed(precision)) || parseFloat(amountAdded),
          count: 1,
          ...(currentPaymentMethod?.isBankTransfer === "Y" && {
            isBankTransfer: "Y",
            financialAccountId: currentPaymentMethod?.financialAccount || null,
            transactionId: currentPaymentMethod?.transactionId || null,
            transactionTime: currentPaymentMethod?.transactionDate ? dayjs(currentPaymentMethod?.transactionDate).format("YYYY-MM-DD HH:mm:ss") : null,
            imageUrl: currentPaymentMethod?.financialFile || null,
          }),
        });
      }
    }
    useTransactionStore.getState().setWalletPayments(walletPayments);
    if (currentPaymentMethod.name.toLowerCase() === "card" || currentPaymentMethod.name.toLowerCase() === "upi") {
      if (wallet && showCustomerWallet) {
        handleWalletPostPayment?.();
      } else if (isNewGiftCardFlag && showGiftCardTopup) {
        handleGiftCardTopupPostPayment?.();
      }
    }
  } else {
    // ... (rest of the original else branch remains unchanged)
    const combinedPaid = isExchange ? activeCart.paid || 0 : activeCart.paid;
    const paidWithCurrent = Number(Math.abs(combinedPaid + parseFloat(value)).toFixed(pricePrecision));
    const maxAllowed = Number(Math.abs(netAmountToPay + overPayedAmount).toFixed(pricePrecision));
    if (paidWithCurrent > maxAllowed && paymentMethod?.name?.toLowerCase() !== "cash") {
      if (isExchange || (paymentMethod.roundOffForPos === "N" && paymentMethod?.integratedPayment === false)) {
        message.warning(`${messages.errors.cart.overpayment_not_allowed}`);
        return;
      }
    }
    const paymentAddons = activeCart.payments;
    const amountAdded = parseFloat(value);
    if (activeCart?.cardPaymentData?.manual) {
      paymentMethod = { ...paymentMethod, ...activeCart?.cardPaymentData?.manual };
    }
    const currentPaymentMethod = paymentMethod;
    let shouldRemoveRedeemPoints = false;

    if (paymentMethod.isloyalty && amountAdded < 0) {
      shouldRemoveRedeemPoints = true;
    }

    const index = paymentAddons.findIndex((p) => {
      if (currentPaymentMethod.isBankTransfer === "Y") return false;
      return p.finPaymentmethodId === currentPaymentMethod.finPaymentmethodId;
    });
    const cardPaymentFlag = activeCart.payments.some((p) => p.authorization === paymentMethod?.authorization);
    if (index >= 0 && (paymentMethod?.name?.toLowerCase() === "card" ? cardPaymentFlag : true)) {
      const newAmount = parseFloat(paymentAddons[index].amount) + parseFloat(amountAdded);
      paymentAddons[index].count = (paymentAddons[index].count || 1) + 1;
      activeCart.advancePayment = activeCart.advancePayment ? activeCart.advancePayment : 0;
      let paidAmount = activeCart.paid + parseFloat(amountAdded);
      paymentAddons[index].amount = parseFloat(newAmount).toFixed(pricePrecision);
      if (paidAmount - Math.abs(netAmountToPay) > 0) {
        // [DI-10] Track amountTendered before capping — preserves audit trail for cash overpayment
        if (currentPaymentMethod?.name?.toLowerCase() === "cash") {
          paymentAddons[index].amountTendered = parseFloat(parseFloat(newAmount).toFixed(pricePrecision));
        }
        paymentAddons[index].amount = paymentAddons[index].amount - (paidAmount - Math.abs(netAmountToPay));
        // cart.change = parseFloat(parseFloat(paidAmount - Math.abs(cart.total + parseFloat(overPayedAmount))).toFixed(pricePrecision));
        activeCart.change = parseFloat(
          parseFloat(paidAmount - Math.abs(Math.abs(netAmountToPay) + (posConfig?.enableChangeRounding === "Y" ? parseFloat(overPayedAmount) : 0))).toFixed(pricePrecision)
        );
      }
    } else {
      if (amountAdded !== 0) {
        activeCart.advancePayment = activeCart.advancePayment ? activeCart.advancePayment : 0;
        let paidAmount = activeCart.paid + parseFloat(amountAdded);
        currentPaymentMethod.amount = parseFloat(amountAdded).toFixed(pricePrecision);
        if (paidAmount - Math.abs(netAmountToPay) > 0) {
          // [DI-10] Track amountTendered before capping — preserves audit trail for cash overpayment
          if (currentPaymentMethod?.name?.toLowerCase() === "cash") {
            currentPaymentMethod.amountTendered = parseFloat(parseFloat(amountAdded).toFixed(pricePrecision));
          }
          currentPaymentMethod.amount = parseFloat(parseFloat(amountAdded).toFixed(pricePrecision)) - (paidAmount - Math.abs(netAmountToPay));
          // cart.change = parseFloat(parseFloat(paidAmount - Math.abs(cart.total + parseFloat(overPayedAmount))).toFixed(pricePrecision));
          activeCart.change = parseFloat(
            parseFloat(paidAmount - Math.abs(Math.abs(netAmountToPay) + (posConfig?.enableChangeRounding === "Y" ? parseFloat(overPayedAmount) : 0))).toFixed(pricePrecision)
          );
        }
        currentPaymentMethod.count = 1;
        paymentAddons.push(currentPaymentMethod);
      }
    }

    let totalAmountAdded = 0;
    const paymentMethodsCount = paymentAddons.length;
    for (let i = 0; i < paymentMethodsCount; i += 1) {
      totalAmountAdded += parseFloat(paymentAddons[i].amount);
    }

    if (paymentMethod.redemptionPoints) {
      activeCart.redemptionPoints = paymentMethod.redemptionPoints;
    }

    const redemptionPts = shouldRemoveRedeemPoints ? 0 : activeCart.redemptionPoints;

    let creditAmountValue = activeCart.creditAmount;
    if (paymentMethod.iscredit && amountAdded > 0) {
      if (activeCart.creditAmount > 0) {
        creditAmountValue = activeCart.creditAmount + amountAdded;
      } else {
        creditAmountValue = amountAdded;
      }
    }

    if (paymentMethod.iscredit && amountAdded < 0) {
      creditAmountValue = 0;
    }
    if (!isExchange) {
      activeCart.total = parseFloat(activeCart.total.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
    }
    if (currentPaymentMethod?.name?.toLowerCase() === "cash") {
      activeCart.tenderedAmount = +value + (+activeCart.tenderedAmount || 0);
    }

    const finalCartObj = {
      ...activeCart,
      paid: parseFloat(parseFloat(totalAmountAdded + activeCart.advancePayment).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)),
      payments: [...paymentAddons],
      redemptionPoints: redemptionPts,
      creditAmount: creditAmountValue,
      ...(isExchange && { netAmountToPay: parseFloat(netAmountToPay.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)) }),
    };

    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (orderTimeDetails.paymentStartTime === "") {
      orderTimeDetails = {
        ...orderTimeDetails,
        paymentStartTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
    }

    usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
    if (isExchange) {
      setExchangeCart?.(finalCartObj);
      useCartStore.getState().setExchangeCart(finalCartObj);
    } else {
      setCart(finalCartObj);
    }
    setSelectedPaymentMethod("");
    // setAmount(
    //   Math.abs(activeCart.total) > Math.abs(totalAmountAdded) + activeCart.advancePayment
    //     ? parseFloat(Math.abs(activeCart.total) - (Math.abs(totalAmountAdded) + activeCart.advancePayment)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)
    //     : ""
    // );
    setAmount(
      Math.abs(netAmountToPay) > Math.abs(totalAmountAdded) + activeCart.advancePayment
        ? parseFloat(Math.abs(netAmountToPay) - (Math.abs(totalAmountAdded) + activeCart.advancePayment)).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)
        : ""
    );
    upsertPOSLog(finalCartObj, "PAY");
    const userAccessController = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
    const layout = userAccessController.layout;
    if (layout === "3") {
      setLayoutType(7);
      localStorage.setItem("layoutType", 7);
      const customEvent1 = new CustomEvent("customStorageChange", {
        detail: { key: "layoutType", newValue: 7 },
      });
      window.dispatchEvent(customEvent1);
      setKioskUI(5);
      const customEvent = new CustomEvent("customStorageChange", {
        detail: { key: "kioskUI", newValue: 5 },
      });
      window.dispatchEvent(customEvent);
      localStorage.setItem("kioskUI", 5);

      setTimeout(() => {
        localStorage.setItem("kioskUI", 0);
        setKioskUI(0);
        const customEvent = new CustomEvent("customStorageChange", {
          detail: { key: "kioskUI", newValue: 0 },
        });
        window.dispatchEvent(customEvent);

        localStorage.setItem("layoutType", 0);
        setLayoutType(0);
        const customEvent1 = new CustomEvent("customStorageChange", {
          detail: { key: "layoutType", newValue: 0 },
        });
        window.dispatchEvent(customEvent1);
      }, 5000);
    }
  }
};
